"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteMapFloorPlans = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useSiteCirrusStorePath_1 = require("../../hooks/useSiteCirrusStorePath");
const MapFloors_1 = require("./MapFloors");
function SiteMapFloorPlans(_a) {
    var { autoCenter = true } = _a, props = __rest(_a, ["autoCenter"]);
    const base = useSiteCirrusStorePath_1.useSiteCirrusStorePath();
    const modelUrl = `${base}/model`;
    return jsx_runtime_1.jsx(MapFloors_1.MapFloors, Object.assign({ autoCenter: autoCenter, baseUrl: modelUrl }, props), void 0);
}
exports.SiteMapFloorPlans = SiteMapFloorPlans;
//# sourceMappingURL=index.js.map